// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import { ReactComponent as LogoText } from 'images/lw-text-logo.svg';
import Button from '@liquidweb-dev/undercurrent/Button';
import { useLogout } from 'modules/oidc/useLogout';

/**
 * @param {object} props
 * @param {import('@liquidweb-dev/undercurrent/Button').ButtonProps} [props.logoutButtonProps]
 */
const LogoutOnly = ({ logoutButtonProps }) => {
	const logout = useLogout();

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<LogoText />
			<Button variant="link" onClick={logout} {...logoutButtonProps}>
				Logout
			</Button>
		</Box>
	);
};

export default LogoutOnly;
